module.exports = __webpack_public_path__ + "static/profil-595_optimized-90ce57d39618cdab6ef840efdf42c330.jpg";